import React, { Component } from "react";
import { Link } from "react-router-dom";
// import "simple-line-icons/css/simple-line-icons.css";
// import "font-awesome/css/font-awesome.min.css";
// import "ti-icons/css/themify-icons.css";
// import "perfect-scrollbar/dist/perfect-scrollbar.min.js";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const getItemStyle = (isDragging, draggableStyle) => ({
  background: isDragging ? "#09cc89" : "white",
  boxShadow: isDragging ? "0 2px 10px #d7d7d7" : "0 2px 10px #d7d7d7",
});

export default class CourseEditor extends Component {
  state = {
    pageName: "",
  };
  addPage = (id) => {
    if (this.state.pageName.length > 0) {
      this.props.addPage(id, this.state.pageName);
    }
    this.setState({ pageName: "" });
  };
  removePage = (id) => {
    this.props.removePage(id);
  };
  addElement = (id) => {
    this.props.addElement(id);
  };
  removeElement = (id) => {
    this.props.removeElement(id);
  };
  closeEditing = (id) => {
    this.props.closeEditing();
  };
  startEditing = (id) => {
    this.props.startEditing(id);
  };
  onPageName = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onDuplicatePage = (id) => {
    this.props.onDuplicatePage(id);
  };
  onRenamePage = (page) => {
    this.props.onRenamePage(page.id);
    this.setState({ renameEditing: true, renamePage: page.name });
  };
  renamePageDone = (id) => {
    this.props.renamePageDone(id, this.state.renamePage);
    this.setState({ renameEditing: false, renamePage: "" });
  };
  onDragCourse = (result) => {
    this.props.onDragCourse(result);
  };
  onDragElement = (result) => {
    this.props.onDragElement(result);
  };
  onDuplicateElement = (id) => {
    this.props.onDuplicateElement(id);
  };
  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    this.props.setTopicName(e.target.value);
  };
  onSave = () => {
    this.props.addTopic();
  };
  render() {
    return (
      <nav className="sidebar sidebar-offcanvas bg-white" id="sidebar">
        <div className="row m-0">
          <div class="card-body border-top">
            {/* <div className="row">
              <div className="w-100 d-flex justify-content-around align-items-center">
                <Link to="/course-units" class="btn btn-secondary btn-fw">
                  BACK
                </Link>
                <Link to="/course-units" class="btn btn-primary btn-fw">
                  SAVE
                </Link>
              </div>
            </div> */}
            <div className="row mt-4 p-2 bg-light font-weight-bold text-success text-uppercase d-flex justify-content-between align-items-center">
              <div className="col-5" onClick={this.closeEditing}>
                All Pages
              </div>

              <div className="col-7">
                {this.props.pageEditing ? (
                  <span>
                    <i className="fa fa-chevron-right text-dark mr-3"></i>
                    {this.props.currentPage.name}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row">
              <div class="col-md-12 mt-4">
                <div className="list-group">
                  {this.props.pageEditing ? (
                    <DragDropContext onDragEnd={this.onDragElement}>
                      <Droppable droppableId="droppable1">
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {this.props.currentPage.elements.map(
                              (element, index) => (
                                <Draggable
                                  key={element.id}
                                  draggableId={element.id}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="pb-3">
                                        <div
                                          style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                          )}
                                          className="list-group-item d-flex justify-content-between"
                                        >
                                          <h5 className="my-1 text-uppercase font-weight-bold">
                                            {element.name}
                                          </h5>
                                          {element.exist ? (
                                            <div className="d-flex justify-content-center">
                                              <button
                                                type="button"
                                                class="badge badge-dark px-2 dropdown-toggle dropdown-toggle-split"
                                                id="dropdownMenuSplitButton1"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                              >
                                                <span className="mr-2 font-weight-bold text-uppercase">
                                                  Option
                                                </span>
                                                <span class="sr-only">
                                                  Toggle Dropdown
                                                </span>
                                              </button>
                                              <div
                                                class="dropdown-menu shadow"
                                                aria-labelledby="dropdownMenuSplitButton1"
                                              >
                                                <h6 class="dropdown-header font-weight-bold border-bottom">
                                                  Options
                                                </h6>
                                                <a
                                                  class="dropdown-item"
                                                  onClick={this.onDuplicateElement.bind(
                                                    this,
                                                    element.id
                                                  )}
                                                >
                                                  Duplicate
                                                </a>
                                                <a
                                                  class="dropdown-item"
                                                  onClick={this.removeElement.bind(
                                                    this,
                                                    element.id
                                                  )}
                                                >
                                                  Remove
                                                </a>
                                              </div>
                                            </div>
                                          ) : (
                                            // <div
                                            //   className="badge badge-danger d-flex justify-content-center align-items-center"
                                            //
                                            // >
                                            //   REMOVE
                                            // </div>

                                            <div
                                              className="badge badge-success font-weight-bold d-flex justify-content-center align-items-center"
                                              onClick={this.addElement.bind(
                                                this,
                                                element.id
                                              )}
                                            >
                                              ADD
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              )
                            )}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  ) : (
                    <DragDropContext onDragEnd={this.onDragCourse}>
                      <Droppable droppableId="droppable2">
                        {(provided, snapshot) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            // style={getListStyle(snapshot.isDraggingOver)}
                          >
                            {this.props.course.map((page, index) => (
                              <Draggable
                                key={page.id}
                                draggableId={page.id}
                                index={index}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <div>
                                      {page.renameEditing ? (
                                        <div className="list-group-item mb-3 d-flex justify-content-between">
                                          <input
                                            type="email"
                                            name="renamePage"
                                            class="form-control form-control-sm mr-3"
                                            placeholder="Enter Page Name"
                                            onChange={this.onPageName}
                                            value={this.state.renamePage}
                                          />
                                          <div
                                            className="badge badge-success d-flex justify-content-center align-items-center"
                                            onClick={this.renamePageDone.bind(
                                              this,
                                              page.id
                                            )}
                                          >
                                            DONE
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="pb-3">
                                          <div
                                            className="list-group-item d-flex justify-content-between align-items-center"
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                          >
                                            <h5 className="my-1 text-uppercase font-weight-bold">
                                              {page.name}
                                            </h5>
                                            {page.exist ? (
                                              <span>
                                                <div class="btn-group">
                                                  <button
                                                    type="button"
                                                    class="btn btn-dark px-2 py-2"
                                                    onClick={this.startEditing.bind(
                                                      this,
                                                      page.id
                                                    )}
                                                  >
                                                    EDIT
                                                  </button>
                                                  <button
                                                    type="button"
                                                    class="btn btn-dark px-2 py-2 dropdown-toggle dropdown-toggle-split"
                                                    id="dropdownMenuSplitButton1"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                  >
                                                    <span class="sr-only">
                                                      Toggle Dropdown
                                                    </span>
                                                  </button>
                                                  <div
                                                    class="dropdown-menu shadow"
                                                    aria-labelledby="dropdownMenuSplitButton1"
                                                  >
                                                    <h6 class="dropdown-header font-weight-bold border-bottom">
                                                      Options
                                                    </h6>
                                                    <a
                                                      class="dropdown-item"
                                                      onClick={this.onDuplicatePage.bind(
                                                        this,
                                                        page.id
                                                      )}
                                                    >
                                                      Duplicate
                                                    </a>
                                                    <a
                                                      class="dropdown-item"
                                                      onClick={this.onRenamePage.bind(
                                                        this,
                                                        page
                                                      )}
                                                    >
                                                      Rename
                                                    </a>
                                                    <a
                                                      class="dropdown-item"
                                                      onClick={this.removePage.bind(
                                                        this,
                                                        page.id
                                                      )}
                                                    >
                                                      Delete
                                                    </a>

                                                    <a
                                                      class="dropdown-item"
                                                      href="#"
                                                    >
                                                      Create save copy
                                                    </a>
                                                  </div>
                                                </div>
                                              </span>
                                            ) : (
                                              <div
                                                className="badge badge-success font-weight-bold d-flex justify-content-center align-items-center"
                                                onClick={this.addPage.bind(
                                                  this,
                                                  page.id
                                                )}
                                              >
                                                ADD
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  )}
                  {this.props.pageEditing ? (
                    ""
                  ) : (
                    <React.Fragment>
                      <h4 className="border-top pt-3">Add New Page</h4>
                      <div className="list-group-item shadow-sm mb-3 d-flex justify-content-between">
                        <input
                          type="email"
                          name="pageName"
                          class="form-control form-control-sm mr-3"
                          placeholder="Enter Page Name"
                          onChange={this.onPageName}
                          value={this.state.pageName}
                        />
                        <div
                          className="badge badge-success font-weight-bold d-flex justify-content-center align-items-center"
                          onClick={this.addPage}
                        >
                          ADD
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            <button
              type="submit"
              class="btn btn-primary btn-fw"
              onClick={this.onSave}
            >
              SAVE
            </button>
            {" "} or{" "}
            <Link to="/admin/courses" className="btn-link">
              Cancel
            </Link>
          </div>
        </div>
      </nav>
    );
  }
}
